var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'--home-color': _vm.$config.homeTeam.color, '--away-color': _vm.$config.awayTeam.color}),attrs:{"id":"app"}},[(_vm.$store.state.loading)?_c('loading'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }